import edsThemes from '@emartech/eds-themes';
import Storage from '../storage';
import { cssVariables } from './css-variables.js';
import { SwitchClient } from './switch-client.js';
import { SwitchService } from './switch-service.js';

export class ThemeHandler {
  #allowedThemeStatuses = ['beta', 'production_ready'];
  #defaultThemeId = 'morningHorizon';

  constructor(storage) {
    this.storage = storage;
    this.switchClient = new SwitchClient(this);
    this.switchService = new SwitchService(this);
  }

  init() {
    this.switchClient.listenOnThemeSwitch();
    this.setThemeManifest(edsThemes);

    if (window === window.top) {
      this.switchService.listenOnChildrenSignal();
    }
  }

  setThemeManifest(themeManifest) {
    this.themeManifest = themeManifest;
    this.switchClient.sendSignal();
    cssVariables.inject(this);
  }

  get defaultTheme() {
    return this.findThemeById(this.#defaultThemeId);
  }

  get availableThemes() {
    return this.themeManifest.themes.filter(theme => this._isThemeAllowed(theme));
  }

  get currentTheme() {
    const storedThemeId = this.storage.getItem('e.ui.colorTheme');
    return this.findThemeById(storedThemeId) || this.defaultTheme;
  }

  get cdnURL() {
    return this.themeManifest.cdnURL;
  }

  get manifestVersion() {
    return this.themeManifest.version;
  }

  switchTheme(theme) {
    const newTheme = theme || this.defaultTheme;
    this.switchService.switchTheme(newTheme);
  }

  getCurrentIconTheme() {
    return this.themeManifest.icons.horizon;
  }

  getCurrentImageTheme() {
    return this.themeManifest.images.horizon;
  }

  findThemeById(themeId) {
    return this.availableThemes.find(theme => theme.id === themeId);
  }

  _isThemeAllowed(theme) {
    return this.#allowedThemeStatuses.includes(theme.properties.status);
  }
}

export default new ThemeHandler(new Storage());
